// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"727":"3ebcff2d","753":"3ebcff2d"}[chunkId] + ".chunk.css";
};